/** Сессия недействительна (invalid_grant, 401 без refresh) — ведём на /login с returnUrl. */
export const SESSION_EXPIRED_FLAG = "auth:session-expired"
export const SESSION_EXPIRED_RETURN_URL = "auth:session-expired-return-url"

const SESSION_EXPIRED_REDIRECT_EVENT = "auth:session-expired-redirect"

export class SessionExpiredError extends Error {
  constructor() {
    super("Session expired")
    this.name = "SessionExpiredError"
  }
}

export const isSessionExpiredError = (error: unknown): error is SessionExpiredError =>
  error instanceof SessionExpiredError

export const dispatchSessionExpiredRedirect = () => {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_REDIRECT_EVENT))
}

export const subscribeSessionExpiredRedirect = (handler: () => void) => {
  if (typeof window === "undefined") return () => {}
  window.addEventListener(SESSION_EXPIRED_REDIRECT_EVENT, handler)
  return () => window.removeEventListener(SESSION_EXPIRED_REDIRECT_EVENT, handler)
}

export const readOAuthErrorCode = (body: unknown): string | null => {
  if (typeof body !== "object" || body === null) return null
  const err = (body as Record<string, unknown>).error
  return typeof err === "string" ? err : null
}
